<mat-dialog-content>
<div id="w3l-appointment" style="width: 1000px;">
  <section class="appointment-section section-gap" >
    <div class="wrapper">


          <form action="#" method="post" >
            <div class="fields-grid" >
              <div class="styled-input" >
                <label style="width: 850px;color: rgb(70, 70, 247);font-weight: bolder;">Preparation Order</label>
                <label style="width: 450px;">Edit Protocol Line</label>
              </div>

              <div class="appointment-form-field" style="width: 1070px;border-collapse: collapse;">
                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: medium;width: 12%;align-self: center;">Category</label>
                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: medium;width: 27%;align-tracks: center;">  Item</label>
                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: medium;width: 6%;align-tracks: center;">Dose</label>
                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: medium;width: 18%;text-align: center;">  Duration</label>
                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: medium;width: 5%;text-align: center;">Step</label>
                <label class="appointment-form-field" style="background-color: rgb(70, 70, 247);color: white; font-weight: bold;font-size: medium;width: 23%;text-align: center;">Notes</label>


              </div>
              <!-- <div class="appointment-form-field">
                <select id="pharmgroups" name="pharmgroups" required=""  style="width: 10%;background-color: white;" [(ngModel)]="prdetcategory" (change)="retriveItemsLookupCat()">
                  <option value="{{grs.serial}}"  *ngFor="let grs of pharmGroupList; let i = index">{{grs.pharmacyGroupName}}</option>
                </select>

                <select id="itemsgroup" name="itemsgroup" required=""  style="width: 23%;background-color: white;" [(ngModel)]="prdetitcode" [value]="prdetitname">
                  <option value="{{itm.itCode}}"  *ngFor="let itm of itemsList; let i = index">{{itm.itTName}}</option>
                </select>
                <input type="text" name="Cost"  required="" placeholder="00.00" style="width: 7%;background-color: white;font-size: small;" [(ngModel)]="prdetqty">
                <input type="text" name="duration"  required="" placeholder="Duration" style="width: 20%;background-color: white;font-size: small;" [(ngModel)]="prdetduration">
                <input type="text" name="step"  required="" value= "1" style="width: 5.5%;background-color: white;font-size: small;" [(ngModel)]="prdetstep">
                <input type="text" name="soloutipn"  required="" placeholder="" style="width: 25.5%;background-color: white;font-size: small;" [(ngModel)]="prdetnotes">


              </div> -->
              <!-- New Line -->
              <div class="appointment-form-field">
                <select id="pharmgroups" name="pharmgroups" required=""  style="width: 12%;background-color: white;" [(ngModel)]="prdetcategory" (change)="retriveItemsLookupCat()">
                  <option value="{{grs.serial}}"  *ngFor="let grs of pharmGroupList; let i = index">{{grs.pharmacyGroupName}}</option>
                </select>
                <input type="text" name="itcode"  required="" placeholder="Item Code" style="width: 10%;background-color: white;font-size: small;" [(ngModel)]="prdetitcode">
                <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialogItems()"></span>
                <input type="text" name="itName"  required="" placeholder="Item Name" style="width: 17%;background-color: white;font-size: small;" [(ngModel)]="prdetitname">

                <input type="text" name="Cost"  required="" placeholder="00.00" style="width: 7%;background-color: white;font-size: small;" [(ngModel)]="prdetqty">
                <input type="text" name="duration"  required="" placeholder="Duration" style="width: 20%;background-color: white;font-size: small;" [(ngModel)]="prdetduration">
                <input type="text" name="step"  required="" value= "1" style="width: 5.5%;background-color: white;font-size: small;" [(ngModel)]="prdetstep">
                <input type="text" name="soloutipn"  required="" placeholder="" style="width: 25.5%;background-color: white;font-size: small;" [(ngModel)]="prdetnotes">


              </div>

              <BR>
              <BR>
            <div style="text-align: center; ">
                <button type="button" class="theme-button btn" name="submit" (click)="submitProtocolDet_1()" >Submit</button>
                <button type="button" class="theme-button btn" name="Delete" (click)="mesgDelete()"  >Delete</button>
                <button type="button" class="theme-button btn" name="New" (click)="CloseDialog()">Close</button>
            </div>
            <div class="clear">

            </div>
          </div>
          </form>

    </div>
  </section>
</div>
</mat-dialog-content>

